export default __webpack_public_path__ + "static/media/gallery_14.f064840f.jpg";